
import login from '../images/tela-login.png';
import partidas from '../images/partidas.png';
import skambooks from '../images/skambooks.png';
import receitas from '../images/receitas.png';
import tela from '../images/tela-classificacao.png';
import covid from '../images/covid.png';
import rick from '../images/rick-morthy.png';
import solar from '../images/solar.png';
import cart from '../images/cart.png';
import create from '../images/create.png';
import blog from '../images/blog.png';
import python from '../images/Flesk.png';
import mario from '../images/mario.png';
import memory from '../images/memory.png';


const carousel = [
  {
    id: 1,
    alt: 'Skambooks',
    src: skambooks,
    title: 'Skambooks',
    descreption: 'Troca de livros'
  },
  {
    id: 2,
    alt: 'login',
    src: login,
    title: 'login',
    descreption: 'Login'
  },
  {
    id: 3,
    alt: 'create',
    src: create,
    title: 'create',
    descreption: 'create'
  },
  {
    id: 4,
    alt: 'Partidas',
    src: partidas,
    title: 'Partidas',
    descreption: 'Buscar partidas'
  },
  {
    id: 5,
    alt: 'receitas',
    src: receitas,
    title: 'receitas',
    descreption: 'Receitas'
  },
  {
    id: 6,
    alt: 'Covid',
    src: covid,
    title: 'Covid',
    descreption: 'Dados Covid'
  },
  {
    id: 7,
    alt: 'Rick',
    src: rick,
    title: 'Rick',
    descreption: 'Dados Rick'
  },
  {
    id: 8,
    alt: 'Solar',
    src: solar,
    title: 'Solar',
    descreption: 'Sistema Solar'
  },
  {
    id: 9,
    alt: 'tela',
    src: tela,
    title: 'tela',
    descreption: 'tela'
  },
  {
    id: 10,
    alt: 'Cart',
    src: cart,
    title: 'Cart',
    descreption: 'Cart shopping'
  },
  {
    id: 11,
    alt: 'memory',
    src: memory,
    title: 'Jogo de memória',
    descreption: 'Jogo de memória'
  },
  {
    id: 12,
    alt: 'mario',
    src: mario,
    title: 'Mario Bros',
    descreption: 'Mario'
  },
  {
    id: 13,
    alt: 'python',
    src: python,
    title: 'Python',
    descreption: 'Python'
  },
  {
    id: 14,
    alt: 'blog',
    src: blog,
    title: 'Blog',
    descreption: 'Blog'
  }
]

export default carousel;